<template>
	<div class="">
		<div class="badgeHeader pl-6 pt-2">
			<router-link to="/badges">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to Badges </span>
			</router-link>
		</div>
		<base-page-heading
			title="Badge Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateName"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>

		<div class="row content">
			<EditBadgesTable
				ref="editbadge"
				:route-id="$route.params.id"
			/>
		</div>
	</div>
</template>

<style scoped>
.badgeHeader{
	background-color: #f6f7f8;
}
</style>
